/* eslint-disable prettier/prettier */
import axios from "axios";

import store from '@/store/store.js'; // path to your Vuex store
import router from '@/router.js'; // path to your Vuex store

axios.defaults.baseURL = "";
axios.defaults.headers = {
  Accept: "application/json",
  "Content-Type": "Application/json"
};


const loginUrl = "/api/login";

// axios.interceptors.response.use(response => {
//   console.log("interceptor response")
//   return response;
// }, 
// error => {
//   debugger
//   if (error.response.status === 401) {
//     //debugger
//     if (error.response.config.url != loginUrl) {    
//       //se siamo sulla pagina del login, non fare redirect
//       console.log("interceptor error")
//       router.push({ name: 'error', params: {error: error.response }})
//     }  

//     //place your reentry code
//     //return error.response;
//     return Promise.reject(error.response);
//   }
//  //debugger
//  //return error.response;
//  return Promise.reject(error.response);
// });



const isHandlerEnabled = (config={}) => {
  return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? 
    false : true
}

const errorHandler = (error) => {
  if (isHandlerEnabled(error.config)) {        
    if (error.response.status == 401) {      
      console.log("logout action called from axios error 401 handler")
      store.dispatch("logout");

      if (error.response.config.url != loginUrl) {           
        //se siamo sulla pagina del login, non fare redirect        
        router.push({ name: 'error', params: {error: error.response }})
      }      
    } else {      
      //errore generico
      router.push({ name: 'error', params: {error: error.response }})
    }    
  }
  //debugger
  //return Promise.reject( { ...error })  //ritorna tutto l'oggetto config error
  return Promise.reject( error.response )
}

const successHandler = (response) => {
  if (isHandlerEnabled(response.config)) {
    // Handle responses
  }

  //se il server chiede un jwt reissue, lo salvo
  if (response.headers["jwt-reissue"]) {    
    var newToken = response.headers["jwt-reissue"];
    store.commit("SET_LOGIN", {
      token: newToken
    });    
  }
  return response;
};

axios.interceptors.response.use(  
  response => successHandler(response),
  error => errorHandler(error)
)

const appService = {
  addAuthHeader(token) {
    console.log("addAuthHeader called")
    var h = axios.defaults.headers;
    h.Authorization = `Bearer ${token}`;
  },

  removeAuthHeader() {
    console.log("removeAuthHeader called")    
    delete axios.defaults.headers.Authorization 
    //axios.defaults.headers.Authorization = "";
  },

  logout() {
    return new Promise(resolve => {
      axios.get("/api/logout").then(response => {
        resolve(response.data);
      });
    });
  },

  deleteBook(id) {
    return new Promise(resolve => {
      var url = `/api/books/${id}`
      axios.delete(url).then(response => {        
        resolve(response.data);
      });
    });
  },


  // async loginAsync(username, password) {    
  //   var loginData = {
  //     name: username,
  //     color: password
  //   };

  //   try {
  //     let response = await axios.post("/api/login", loginData)
  //     debugger
  //     return response;
  //   } catch (error) {
  //     debugger
  //     //per qualche ragione "error" da solo non è visibile nel debugger
  //     //https://stackoverflow.com/questions/46081146/async-await-with-axios-not-returning-errors
  //     console.log(error.response)     
  //     throw(error) //il throw è necessario per ritrovarlo dopo
  //   }    
  // },

 loginAsync(username, password) {
   console.log("service loginAsync called")
    var loginData = {
      name: username,
      color: password
    };
    
    return axios.post("/api/login", loginData)      
    .then(data => {
      console.log("axios /api/login then()")
      //debugger
      return data
    })
    .catch(error => {
      console.log("axios /api/login catch()")      
      //per qualche ragione "error" da solo non è visibile nel debugger
      //https://stackoverflow.com/questions/46081146/async-await-with-axios-not-returning-errors
      console.log(error)    
      
      throw(error) //il throw è necessario per ritrovarlo dopo
    })
  },

  async insertBook(book){
    try {      
      let response = await axios.post("/api/books/insert", book)      
      return response;
    } catch (error) {
      console.log(error.response)     
      throw(error.response) //il throw è necessario per ritrovarlo dopo
    }    
  },

  async checkBookIdExists(id){
    try {
      let response = await axios.get("/api/books/exist/"+ id)      
      return response;
    } catch (error) {
      console.log(error.response)     
      throw(error.response) //il throw è necessario per ritrovarlo dopo
    }    
  },

  async getBooksMaxId(){
    try {
      let response = await axios.get("/api/books/maxid")
      return response;
    } catch (error) {
      console.log(error.response)
      throw(error.response) //il throw è necessario per ritrovarlo dopo
    }    
  },

  async getAuthorsIndex(){
    try {
      let response = await axios.get("/api/index")
      return response;
    } catch (error) {
      console.log(error.response)
      throw(error.response) //il throw è necessario per ritrovarlo dopo
    }    
  },

  async getAuthors(initial){
    try {
      let response = await axios.get("/api/authors/" + initial)
      return response;
    } catch (error) {
      console.log(error.response)
      throw(error.response) //il throw è necessario per ritrovarlo dopo
    }    
  }
};

export default appService;